import { Auth } from '../components/auth/cognito_auth';
import axios from 'axios'

var AWS = require("aws-sdk/global");


const properties = {
	invokeUrl: process.env.VUE_APP_AWS_API_GATEWAY_FEEDBACK_INVOKATION_URL,
	guestPath: '/feedback/guest',
	membersPath: '/feedback/members'
}


export default {
	name: 'FeedbackService',

	postFeedbackPromise: function (comment, rating) {
		var feedback = {
			comment: comment,
			rating: rating + ""
		}
		return AWS.config.credentials.getPromise().then(function () {
			var id_token = Auth.getIdToken();
			return axios.post(properties.invokeUrl + properties.membersPath, feedback, {
				headers: {
					Authorization: `Bearer ${id_token}`
				}
			})
			
		}, function (err) {
			axios.post(properties.invokeUrl + properties.guestPath, feedback)
			return err
		})
	}
}
